import { PreferenceSelection } from './preference-selection.model';

export class PreferenceCategory {
  id: string;
  preferences: Array<object>;

  constructor(data, updates) {
    let category = (data || {});
    this.id = (category.key || category.id || '');
    this.preferences = [];
    this._mapData(category.preferences, updates);
  }

  _mapData(preferences, updates) {
    if(!!preferences){
      preferences.forEach((preference) => {
        this.preferences.push(new PreferenceSelection(preference, updates));
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/user/stay-preferences/preference-category.model.ts